import { translate } from "../../../util/translate"

export const categoriesHeader = [
  {
    text: translate['category.label.name'],
    value: 'name',
  },
  { value: 'actions', align: 'end', width: '100' },
]
